module.exports = __webpack_public_path__ + "media/images/admin/icons/shuffle-60f9614fd584355aa03b9d5ffcc3b395.svg";